var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "componentTab table" }, [
    _c(
      "table",
      [
        _vm._l(_vm.values, function(value) {
          return _c("tr", { key: value.label }, [
            _c("td", [_vm._v(_vm._s(value.label))]),
            _c("td", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.numberSpacing(value.value)))
            ])
          ])
        }),
        _vm._l(_vm.totals, function(total, index) {
          return _c(
            "tr",
            {
              key: total.label,
              staticClass: "total",
              class: { "no-border": index + 1 == _vm.totals.length }
            },
            [
              _c("td", [_vm._v(_vm._s(total.label))]),
              _c("td", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.numberSpacing(total.value)))
              ])
            ]
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }